import { debounceTime } from "rxjs/operators";
import { Subject } from "rxjs";
import {
    Component,
    OnInit,
    Input,
    Output,
    EventEmitter,
    ViewEncapsulation,
    OnDestroy,
    ElementRef
} from '@angular/core';
import { FnTimepickerService } from './../services/timepicker.service';
import { isEmptyString, isNull } from '../../../util/check';

@Component({
    selector: 'fn-time-picker',
    templateUrl: 'fn-time-picker.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class FnTimePickerComponent implements OnInit, OnDestroy {
    @Input() index: number;
    @Input() placeholder: string;
    @Input() isMilitryTime: boolean;
    @Output() timeChanged: EventEmitter<number> = new EventEmitter();
    @Input() appendTo: string;
    @Input() name: string;
    @Input() parentForm: any;
    @Input() isDisabled = false;
    @Input() isNextDay = false;
    @Input() nextDayIndex = 0;
    @Input() timeRangeIndex: number;

    isAppendDropDown: boolean = false;
    public debounceValue: Subject<KeyboardEvent> = new Subject();
    errorMessage: string;
    uiItemArray: Array<string> = [];
    searchTerm = '';
    showDropDown = false;
    public activeItem = 0;
    protected validValueRegex: RegExp;
    protected dropDownElem: HTMLElement;
    protected mainItemArray: Array<string> = [];
    protected nativeElem: HTMLElement;
    dropDownID = '';

    constructor(
        protected timePickerSvcs: FnTimepickerService,
        protected elemeRef: ElementRef
    ) {
        this.debounceValue.pipe(debounceTime(200)).subscribe((event) => {
            this.filterTime(event);
        });
    }
    setShowDropDown() {
        this.isAppendDropDown = this.uiItemArray.length > 0;
    }

    searchEvent(event: KeyboardEvent) {
        this.debounceValue.next(event);
    }

    toggleSelect(toggelValue: boolean) {
        this.showDropDown = !toggelValue;
    }
    setErrorMessage() {
        if (this.index < 0) {
            this.errorMessage =
                (this.index === -2 ? 'REQUIRED_' : 'INVALID_') + this.name;
            return;
        }
        this.errorMessage = undefined;
    }
    protected setDropDownFromRange() {
        if (this.index > -1) {
            this.activeItem = 0;
            let value = this.index - this.timeRangeIndex;
            if (value < 0) {
                value += 96;
            };
            this.uiItemArray = this.mainItemArray.slice(
                value,
                this.mainItemArray.length
            );
        }
    }
    ngOnDestroy() { }

    ngOnInit() {
        this.nativeElem = this.appendTo
            ? document.querySelector(this.appendTo)
            : this.elemeRef.nativeElement;
        this.setDefaultData();

        this.setValueByIndex(this.index);
    }

    protected setValueByIndex(value: number) {
        if (value > -1) {
            value = this.index - this.timeRangeIndex;
            if (value < 0) {
                value += 96;
            }
            this.searchTerm = this.mainItemArray[value];
            this.setDropDownFromRange();
        } else {
            this.index = -2;
            this.uiItemArray = this.mainItemArray;
            this.searchTerm = '';
        }
        this.setErrorMessage();
        this.activeItem = 0;
    }
    /**
     * Method to set default data when component is loaded
     */
    protected setDefaultData() {
        this.isMilitryTime =
            this.isMilitryTime === undefined
                ? this.timePickerSvcs.isMilitaryTime
                : this.isMilitryTime;

        if (this.isMilitryTime) {
            this.placeholder = 'hh:mm';
            this.mainItemArray = this.timePickerSvcs.Hour24Format;
            this.validValueRegex = this.timePickerSvcs.regexMap.regexMilitary;
        } else {
            this.placeholder = 'hh:mm a';
            this.mainItemArray = this.timePickerSvcs.Hour12Format;
            this.validValueRegex = this.timePickerSvcs.regexMap.regex12ap;
        }
        if (!isNull(this.timeRangeIndex)) {
            this.mainItemArray = this.timePickerSvcs.create24HrsTimeStampArray(this.timeRangeIndex);
        }
        this.timeRangeIndex = this.timeRangeIndex || 0;
    }

    // onSelectEvent is call after click on li option in ul after apply filter
    onItemClick() {
        this.searchTerm = this.getActiveTime();
        this.setIndexAndEmitEvent();
        this.closeDropDown();
    }

    /**
     * open drop down on Input click if no Time is selected.
     */
    inputClick() {
        if (!this.showDropDown) {
            this.openDropDown();
        }
    }
    /**
     * Open drop down
     */
    protected openDropDown() {
        this.toggleSelect(false);
    }
    /**
     * close drop down
     */
    closeDropDown() {
        this.toggleSelect(true);
        this.setDropDownFromRange();
        this.setErrorMessage();
    }
    keydownEvent(event: KeyboardEvent) {
        if (this.uiItemArray.length > 0) {
            switch (event.key) {
                case this.timePickerSvcs.KEY_CODES.ENTER:
                    this.selectTimeOnEnter();
                    break;
                case this.timePickerSvcs.KEY_CODES.ARROW_UP:
                    this.setActiveTimeOnArrowKey(true);
                    break;
                case this.timePickerSvcs.KEY_CODES.ARROW_DOWN:
                    this.setActiveTimeOnArrowKey(false);
                    break;
                default:
                    break;
            }
        }
        event.stopPropagation();
    }

    protected isSearchItem(event: Event) {
        if (isNull(this.searchTerm) || isEmptyString(this.searchTerm)) {
            this.index = -2;
            this.emitTimeChangeEvent(null);
            this.uiItemArray = this.mainItemArray;
            return false;
        }
        this.index = -1;
        if (event) {
            event.stopPropagation();
        }
        return true;
    }

    protected filterTime(event: Event) {
        if (this.isSearchItem(event)) {
            this.uiItemArray = [];
            if (this.isMilitryTime) {
                this.filterMilitaryTime();
            } else {
                this.filter12HourTime();
            }
            this.setIndexValueOnKeyUp();
        }
    }

    private setIndexValueOnKeyUp() {
        if (this.validValueRegex.test(this.searchTerm)) {
            this.setIndexAndEmitEvent();
            this.setDropDownFromRange();
        } else {
            this.emitTimeChangeEvent(null);
        }
        if (this.uiItemArray.length === 0) {
            this.toggleSelect(false);
            this.activeItem = -1;
        } else {
            this.activeItem = 0;
        }
    }
    private selectTimeOnEnter() {
        if (!this.showDropDown) {
            this.openDropDown();
        } else if (this.activeItem > -1) {
            this.onItemClick();
        }
    }
    protected setActiveTimeOnArrowKey(isKeyup: boolean) {
        this.openDropDown();
        this.calActiveValue(isKeyup);
        this.searchTerm = this.getActiveTime();
        this.setIndexAndEmitEvent();
        if (this.uiItemArray.length > 5) {
            this.setItemScroll();
        }
    }
    protected setItemScroll(isSetItem?: boolean) {
        if (!this.dropDownElem || isSetItem) {
            this.dropDownElem = this.nativeElem.querySelector('.fn-time-picker-ul');
            setTimeout(() => {
                this.setItemScroll();
            });
        } else {
            this.dropDownElem.scrollTop = this.activeItem * 30;
        }
    }
    protected calActiveValue(isKeyUp: boolean) {
        this.activeItem = isKeyUp
            ? this.activeItem < 1
                ? this.uiItemArray.length - 1
                : this.activeItem - 1
            : this.activeItem + 2 > this.uiItemArray.length
                ? 0
                : this.activeItem + 1;
    }
    private setIndexAndEmitEvent() {
        this.index = this.timePickerSvcs.getIndexForOneDayFormat(this.searchTerm);
        this.emitTimeChangeEvent(this.index);
    }
    protected emitTimeChangeEvent(value: number) {
        this.timeChanged.emit(value);
    }

    private filterMilitaryTime() {
        const term = this.searchTerm.toString().split(':');
        const modifiedTerm =
            Number(term[0]) < 10 && !term[0].toString().startsWith('0')
                ? '0' + term[0] + (term.length > 1 ? ':' + term[1] : '')
                : this.searchTerm;
        this.addToUiArray(modifiedTerm, '');
    }
    private filter12HourTime() {
        if (this.timePickerSvcs.regexMap.endWith12aOrp.test(this.searchTerm)) {
            const endWith = this.searchTerm[this.searchTerm.length - 1];
            const startIndex = this.timePickerSvcs.getIndexForOneDayFormat(
                this.searchTerm.replace(endWith, '') + ':00' + endWith
            );
            this.uiItemArray = this.mainItemArray.slice(
                startIndex,
                this.mainItemArray.length
            );
        } else {
            this.addToUiArray(this.searchTerm, '');
        }
    }
    private addToUiArray(modifiedTerm: string, includeText: string) {
        for (let i = 0; i < this.mainItemArray.length; i++) {
            const value = this.mainItemArray[i];
            if (value.startsWith(modifiedTerm) && value.includes(includeText)) {
                this.uiItemArray.push(value);
            }
        }
    }
    protected getActiveTime() {
        return this.uiItemArray[this.activeItem];
    }


    //   retrictAlphaCharKeys(event: KeyboardEvent) {
    //     const keyCode = event.which || event.keyCode;
    //     if (
    //       (!event.shiftKey && keyCode >= 48 && keyCode <= 57) ||
    // 	  (event.keyCode >= 37 && event.keyCode <= 40) ||
    // 	  (event.keyCode >= 96 && event.keyCode <= 105) ||
    //       event.keyCode === 8 || event.keyCode === 46 ||
    //       event.key === ':'
    //     ) {
    //       return true;
    //     }
    //     event.preventDefault();
    //     event.stopPropagation();
    //   }
}
